module.exports = __webpack_public_path__ + "static/media/hmi_shield_logo.246da5d0.png";